export enum OperationType {
  ADD = "ADD",
  EDIT= "EDIT"
}